import { deleteEmptyObj } from '@/utils/utils'
import _ from 'lodash'

const state = {
  // 搜索条件
  real_name: '',
  class_ids: [],
  status: '',
  // table
  page: 1,
  total: 0,
  limit: 15,
  contestId: '',
  multipleSelection: [],
  classList: [],
  isSelectAll: false,
  isIndeterminateAll: false,
  // 缓存
  cacheMap: new Map(),
  // 比赛场次列表
  contestSessionList: [],
  // 学生已选择场次信息
  studentCheckedSession: null
}

const getClassList = (page, limit, params) =>
  API.get(`/edu/zone/contest/class/list?page=${page}&limit=${limit}`, params)
const getStudentList = (params) => API.get('/edu/zone/contest/class/student/list', params)
const getClassStudentCount = (params) => API.post('/edu/zone/contest/class/student/count', params)

const actions = {
  // 获取班级列表数据 初始化
  async batchApplyGetClassData({ state, commit }, contestId) {
    contestId = contestId || state.contestId
    state.contestId = contestId
    const {
      page,
      limit,
      class_ids
      // status,
      // real_name,
      // cacheMap
    } = state
    const params = {
      classIds: class_ids.join(',')
    }
    deleteEmptyObj(params)
    const res = await getClassList(page, limit, params)
    // const res = { data: {} }
    // res.data.items = mock_data
    const classIds = res.data.items && res.data.items.map(({ classId }) => classId)
    const { data } = await getClassStudentCount({ classIds })
    // 数据处理
    const items = await Promise.all(
      res.data.items &&
        res.data.items.map(async ({ classId, className, studentList = [], ...rest }) => {
          // const { isExpand = false } = cacheMap.get(classId) || {}
          const { studentCount = 0 } =
            (Array.isArray(data) && data.find((item) => classId === item.classId)) || {}
          const result = {
            classId,
            className,
            isIndeterminate: false,
            // isExpand: rest.isExpand || isExpand,
            isExpand: false,
            isSelected: false,
            loading: false,
            studentList,
            totalCount: studentCount
            // getStudentList: getStudentList({ contestId, classId, state: status, fullName: real_name })
          }
          // 如果是展开状态 获取学生列表数据
          /* if (isExpand) {
        const { data } = await getStudentList({ contestId, classId, state: status, fullName: real_name })
        result.studentList = data || []
      }
      result.studentList = result.studentList.map((item) => ({ ...item, classId, isSelected: false })) */
          return result
        })
    )
    // 设置数据
    commit('BATCH_APPLY_SET_BASE_DATA', { ...res.data, items, contestId })
    return res
  },
  // 获取学生数据
  async batchApplyGetStudentData({ state, commit }, classId) {
    const { status, real_name, contestId, isSelectAll, cacheMap } = state
    const { isSelected = false } = cacheMap.get(classId) || {}
    commit('BATCH_APPLY_SET_CLASS_LOADING', { classId, loading: true })
    const res = await getStudentList({ contestId, classId, state: status, fullName: real_name })
    commit('BATCH_APPLY_SET_CLASS_LOADING', { classId, loading: false })
    commit('BATCH_APPLY_SET_STUDENT_DATA', {
      studentList: res.data.map((item) => ({
        ...item,
        classId,
        isSelected: isSelected || isSelectAll || false
      })),
      classId
    })
    return res
  },
  // 导出批量报名列表
  async batchApplyExportExcel(state, params) {
    deleteEmptyObj(params)
    try {
      const res = await API.post('/edu/zone/contest/class/student/export', params, {
        responseType: 'arraybuffer',
        timeout: 0
      })
      return res
    } catch (err) {
      return err
    }
  },
  // 导入批量报名列表
  async batchApplyImportExcel({ state }, params) {
    return API.post('/edu/zone/contest/class/student/import', params, { timeout: 5 * 60 * 1000 })
  },
  // 批量报名
  async batchSign(state, { accountIds, sessionId, contestId, classIds }) {
    const params = {
      accountIds,
      sessionId,
      contestId,
      classIds
    }
    const res = await API.post(`/edu/zone/contest/student/sign/up`, params, {
      timeout: 5 * 60 * 1000
    })
    return res
  },
  // 批量修改场次
  async batchUpdate(state, { userIdList, sessionId, contestId }) {
    const params = {
      userIdList,
      sessionId,
      contestId
    }
    const res = await API.post(`/edu/zone/contest/student/session/batchUpdate`, params, {
      timeout: 5 * 60 * 1000
    })
    return res
  },
  // 批量删除报名考生
  async batchDelete(state, { userIdList, sessionId, contestId }) {
    const params = {
      userIdList,
      contestId
    }
    const res = await API.post(`/edu/zone/contest/student/bathDelete`, params)
    return res
  },
  // 检查班级下学生待补全信息的人数
  async batchApplyCheckStudentInfo() {
    return API.get('/edu/zone/contest/student/info/complete/check')
  },
  // 下载报名错误报告
  batchApplyDownSignFailReport({ state }, reportId) {
    try {
      return API.get(
        '/edu/zone/contest/student/sign/up/report',
        { reportId },
        {
          responseType: 'arraybuffer',
          timeout: 0
        }
      )
    } catch (err) {
      return err
    }
  },
  // 下载导入错误报告
  batchApplyDownImportFailReport({ state }, reportId) {
    try {
      return API.get(
        '/edu/zone/contest/class/student/import/report',
        { reportId },
        {
          responseType: 'arraybuffer',
          timeout: 0
        }
      )
    } catch (err) {
      return err
    }
  },
  // 获取学生已选择场次信息
  async getStudentCheckedSession({ commit }, { contestId, accountId }) {
    const res = await API.get('/edu/zone/contest/student/session/view', { contestId, accountId })
    commit('setState', {
      module: 'contest',
      key: 'studentCheckedSession',
      value: res.data
    })
  },
  // 获取比赛场次列表
  async getContestSessionList({ commit }, contestId) {
    const res = await API.get('/edu/zone/contest/session/list', { contestId })
    commit('setState', {
      module: 'contest',
      key: 'contestSessionList',
      value: res.data
    })
  },
  // 更新学生信息
  async updateStudentInfo({ commit }, { params, ...rest }) {
    params.identityType = params.identityType || null
    const res = await API.post('/edu/zone/contest/student/info/update', params)
    return res
  }
}

const mutations = {
  BATCH_APPLY_SET_BASE_DATA(state, { items, contestId, limit, page, total }) {
    // 每次重置cacheMap
    const cacheMap = new Map()
    Array.isArray(items) && items.map((item) => cacheMap.set(item.classId, item))
    state.classList = [...cacheMap.values()]
    state.cacheMap = cacheMap
    state.contestId = contestId
    state.limit = limit
    state.page = page
    state.total = total
    state.isSelectAll = false
    state.isIndeterminateAll = false
    state.selectedClassIds = []
  },
  // 设置学生数据
  BATCH_APPLY_SET_STUDENT_DATA(state, { classId, studentList }) {
    const classData = state.cacheMap.get(classId)
    state.cacheMap.set(classId, { ...classData, studentList })
    state.cacheMap = _.cloneDeep(state.cacheMap)
  },
  // 单个班级数据加载loading
  BATCH_APPLY_SET_CLASS_LOADING(state, { classId, loading }) {
    const classData = state.cacheMap.get(classId)
    state.cacheMap.set(classId, { ...classData, loading })
    state.cacheMap = _.cloneDeep(state.cacheMap)
  },
  // 折叠操作设置 isExpand 标志位
  BATCH_APPLY_SET_TOGGLE_EXPAND(state, classId) {
    const classData = state.cacheMap.get(classId)
    const { isExpand } = classData
    state.cacheMap.set(classId, { ...classData, isExpand: !isExpand })
    state.cacheMap = _.cloneDeep(state.cacheMap)
  },
  // 选择全部
  BATCH_APPLY_SELECT_ALL(state, isSelectedAll) {
    const cacheMap = new Map()
    state.cacheMap.size &&
      [...state.cacheMap.values()].forEach((item) => {
        item.selection = []
        item.studentList =
          item.studentList &&
          item.studentList.map((studentItem) => {
            item.selection.push(studentItem)
            return {
              ...studentItem,
              isSelected: isSelectedAll
            }
          })
        cacheMap.set(item.classId, {
          ...item,
          isSelected: isSelectedAll,
          isIndeterminate: false
        })
      })
    state.cacheMap = cacheMap
    state.isIndeterminateAll = false
  },
  // 选择班级
  BATCH_APPLY_SELECT_CLASS(state, { classId, isChecked }) {
    const { studentList, isExpand, ...rest } = state.cacheMap.get(classId)
    const result = studentList && studentList.map((item) => ({ ...item, isSelected: isChecked }))
    state.cacheMap.set(classId, {
      ...rest,
      studentList: result,
      isSelected: isChecked,
      isExpand: isChecked || isExpand, // 选中状态展开
      isIndeterminate: false
    })
    state.cacheMap = _.cloneDeep(state.cacheMap)
    // 计算 isSelectAll isIndeterminateAll
    const allClass = [...state.cacheMap.values()]
    const isSelectedClass = allClass.filter(({ isSelected, isIndeterminate }) => {
      return isSelected || isIndeterminate
    })
    state.isSelectAll = isSelectedClass.length === allClass.length
    state.isIndeterminateAll =
      isSelectedClass.length > 0 && isSelectedClass.length < allClass.length
  },
  // 单个 handleItemSelectChange
  BATCH_APPLY_ITEM_SELECT_CHANGE(state, { classId, isChecked, accountId }) {
    console.log(`BATCH_APPLY_ITEM_SELECT_CHANGE=>${classId} accountId: ${accountId}`)
    const { studentList, ...rest } = state.cacheMap.get(classId)
    const newStudentList =
      studentList &&
      studentList.map((item) => {
        return item.accountId === accountId
          ? {
            ...item,
            isSelected: isChecked
          }
          : item
      })
    const isSelectedItems = newStudentList.filter(({ isSelected }) => isSelected)
    state.cacheMap.set(classId, {
      ...rest,
      studentList: newStudentList,
      isSelected: isSelectedItems.length === studentList.length,
      isIndeterminate: isSelectedItems.length > 0 && isSelectedItems.length < studentList.length
    })
    state.cacheMap = _.cloneDeep(state.cacheMap)
    // 计算 isSelectAll isIndeterminateAll
    const allClass = [...state.cacheMap.values()]
    const isSelectedClass = allClass.filter(({ isSelected }) => isSelected)
    state.isSelectAll = isSelectedClass.length === allClass.length
    state.isIndeterminateAll =
      isSelectedClass.length > 0 && isSelectedClass.length < allClass.length
  },
  // 页码改变
  BATCH_APPLY_PAGINATION_CHANGE(state, { page = 1, limit = 15 }) {
    state.page = page
    state.limit = limit
  },
  // 批量报名列表数据
  BATCH_APPLY_INIT_FROM_PARAMS(state) {
    state.page = 1
    state.total = 0
    state.limit = 15
    state.real_name = ''
    state.status = ''
    state.class_ids = []
  }
}

export default {
  state,
  actions,
  mutations
}
